import { render, staticRenderFns } from "./TravelNotes.vue?vue&type=template&id=33535e08&scoped=true"
import script from "./TravelNotes.vue?vue&type=script&lang=js"
export * from "./TravelNotes.vue?vue&type=script&lang=js"
import style0 from "./TravelNotes.vue?vue&type=style&index=0&id=33535e08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33535e08",
  null
  
)

export default component.exports